import { useState, useEffect } from 'react';
import { FaSignInAlt } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { login, reset } from '../features/auth/authSlice';
import Spinner from '../components/Spinner';
import { Button, Container } from 'react-bootstrap';
import toastConfig from '../app/toast-config';
  
  function Login() {
      const [ formData, setFormData ] = useState({
          email: '',
          password: ''
      })
  
      const {email, password} = formData;

      const navigate = useNavigate();
      const dispatch = useDispatch();

      const { user, isLoading, isError, isSuccess, message } = useSelector((state) => state.auth);
    
      useEffect(() => {
        if(isError) {
          toast.error(message, toastConfig);
        }
        if(isSuccess || user) {
          navigate('/');
        }

        dispatch(reset());
      }, [user, isError, isSuccess, message, navigate, dispatch]);
      
      const onChange = (e) => {
          setFormData((previousState) => ({
              ...previousState,
              [e.target.name]: e.target.value,
          }));
      };
  
      const onSubmit = (e) => {
          e.preventDefault();

          const userData = {
            email,
            password
          }

          dispatch(login(userData));
      };
      
      // if(isLoading) {
      //   return <Spinner />
      // }

      return (
         <>
          <Container className="text-center">
            <section className='heading'>
              <h1>
                <FaSignInAlt /> Login
              </h1>
            </section>
            <section className='form'>
              <form onSubmit={onSubmit}>
                <div className="form-group">
                    <input type="email" className="form-control" id='email' name='email' value={email} placeholder='Enter your email' onChange={onChange} />
                </div>
                <div className="form-group">
                    <input type="password" className="form-control" id='password' name='password' value={password} placeholder='Enter your password' onChange={onChange} />
                </div>
                <div className="form-group d-grid gap-2">
                    <Button variant="dark" type='submit' className='btn-custom'>
                        Submit
                    </Button>
                </div>
              </form>
              </section>
            </Container>
         </>
      )
  }

export default Login